














































import { Component, Vue, Prop } from 'vue-property-decorator'
import { PopUnitData, PopUnitFilter, getListByUser } from '@/api/heritageUnit/heritageUnit'
import { DDLItem, getHeritageLevel } from '@/api/common/select'
import { enFirstType } from '@/configs/enums'
import FormDialog from '@/components/dialog/formDialog.vue'

@Component({
  components: {
    FormDialog
  }
})
export default class UnitSearchForm extends Vue {
  public name = 'UnitSearchForm'

  //是否多选
  @Prop({ default: false })
  public isMulti: boolean = false
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false
  public popPageSize: number = window.baseConfig.PopPageSize
  public loading: boolean = false
  public levelList: DDLItem[] = []
  public itemList: PopUnitData[] = []
  public queryTerm: PopUnitFilter = {
    Page: 1,
    PageSize: this.popPageSize,
    CityId: 0,
    CountyId: 0,
    LevelId: 0,
    Keyword: ""
  }
  public totalItems: number = 0
  public hasMore: boolean = false
  public selectedItems: PopUnitData[] = []
  public rowClassName(data: { row: any, rowIndex: number }) {
    const row = data.row
    let name = ''
    if (this.selectedItems.findIndex((v: PopUnitData) => v.UnitId == row.UnitId) > -1) {
      name = 'row-checked'
    }
    return name
  }

  public mounted() {
    window.eventBus.$on("openUnitSearchForm", () => {
      this.open()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("openUnitSearchForm")
  }
  public open() {
    this.showDialog = true
    //重置控件
    this.totalItems = 0
    this.hasMore = false
    this.queryTerm = {
      Page: 1,
      PageSize: this.popPageSize,
      CityId: 0,
      CountyId: 0,
      LevelId: 0,
      Keyword: ""
    }
    this.itemList = []
    this.fetchSource()
  }
  public close() {
    this.showDialog = false
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchSource() {
    if (this.levelList.length == 0) {
      getHeritageLevel(enFirstType.All).then((response: { data: any }) => {
        this.levelList = response.data
      })
    }
  }
  // 查询用户所在地的文保单位
  public doSearch() {
    this.queryTerm.Page = 1
    this.itemList = []
    this.selectedItems = []
    this.fetchData()
  }
  public fetchData() {
    this.loading = true
    this.totalItems = 0
    getListByUser(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        //后台读取pageSize条，第pageSize条用来判断是否全部查询
        const list = data.Results
        const pageSize = this.queryTerm.PageSize
        this.totalItems = data.TotalCount
        const curList = this.itemList
        if (curList.length == 0) {
          this.itemList = list
        }
        else {
          this.itemList = curList.concat(list)
        }
        this.hasMore = (this.totalItems > this.itemList.length)
        this.loading = false
      }
    })
  }
  public fetchMore() {
    if (this.hasMore) {
      this.queryTerm.Page++
      this.fetchData()
    }
  }
  //多选
  public itemSelected(val: PopUnitData[]) {
    if (this.isMulti) {
      this.selectedItems = val
    }
  }
  // 单选
  public itemChange(row: PopUnitData, oldRow: PopUnitData) {
    if (!this.isMulti) {
      this.selectedItems = []
      if (row) {
        this.selectedItems.push(row)
      }
    }
  }
  public sendData(data: PopUnitData[]) {
    window.eventBus.$emit("submitUnitSearchForm", data)
  }
  // 确定事件
  public getItems() {
    //回传给父组件
    this.sendData(this.selectedItems)
    this.showDialog = false
  }
}
